import { PUT } from 'dealer-sagas/src/consts/methods'
import apiCall from '../apiCall'

interface CreateBetParams {
  offerId: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const acceptBuyNowContract = async ({ offerId }: CreateBetParams): Promise<any> => {
  const endpoint = '/api/v2/buy_now_contracts/accept'
  const params = { buy_now_contract: { offer_id: offerId } }
  return await apiCall({ endpoint, params, method: PUT })
}
